import { render, staticRenderFns } from "./HrSalaryLabor.vue?vue&type=template&id=259d3ac0&scoped=true&"
import script from "./HrSalaryLabor.vue?vue&type=script&lang=js&"
export * from "./HrSalaryLabor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d3ac0",
  null
  
)

export default component.exports